import { estimateConstants } from '../constants/actionTypes'

const initialState = {
  isFetching: false,
}

export function individualEstimate(state = initialState, action) {
  switch (action.type) {
    case estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_SUCCESS:
      return {
        ...state,
        estimate: action.estimate || {},
        isFetching: false,
        selectedEstimateId: action.estimateId,
        afterMarketAccessories: action.afterMarketAccessories,
        isProposal: action.isProposal,
        proposalNumber: action.proposalNumber,
        dateOfProposalAcceptance: action.dateOfProposalAcceptance,
      }
    case estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_ERROR:
      const { [action.estimateId]: deletedKey, ...others } = state
      return {
        ...others,
        isFetching: false,
        errorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
